import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/auth',
    component: () => import('layouts/LoginLayout.vue'),
    meta: { requiresAuth: false },
    children: [
      { path: 'login', name: 'login', component: () => import('pages/auth/Login.vue') },
      { path: 'lock', name: 'lock', component: () => import('pages/auth/LockScreen.vue') },
    ],
  },
  {
    path: '/',
    component: () => import('layouts/Master.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '', name: 'marketing', component: () => import('pages/Marketing.vue'), meta: { name: 'Marketing' } },
      { path: 'sales', name: 'sales', component: () => import('pages/Sales.vue'), meta: { name: 'Dashboard' } },
      // { path: 'devices', name: 'devices', component: () => import('pages/Devices.vue'), meta: { name: 'Dispositivi', icon: 'mdi-cellphone-link' } },
    ],
  },
  { path: '/privacy', name: 'privacy', component: () => import('pages/Privacy.vue'), meta: { public: true } },
  { path: '/402', component: () => import('pages/ErrorSubscriptionBlocked.vue') },
  { path: '/403', component: () => import('pages/Error403.vue') },
  { path: '/423', component: () => import('pages/ErrorAppNotActive.vue') },
  { path: '/:catchAll(.*)*', component: () => import('pages/Error404.vue') },
]

export default routes
